import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory}  from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarToefl from "../element/CarToefl";
import Menu from './Menu';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
import dataContext from "../context/User";
// Helper 
import GetFetch from '../helper/GetFetch';
// import ShortData from '../helper/ShortData';
import loadMenu from '../js/main';
import Footer from './Footer';

const Toefl = () => {

  const history = useHistory();

  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
 
  const [toefl, setToefl] = useState({});
  const [solvencia, setSolvencia] = useState();
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
       dataUser.token = cred.token;
       dataUser.nombre = cred.nombre;
       dataUser.carnet = cred.carnet;
       dataUser.perfil = cred.perfil;
       dataUser.carrera = cred.carrera;

      let toeflD = GetFetch.toefl(cred.carnet, cred.token);      
      toeflD.then((dataT) => {
        setToefl(dataT);
        if(localStorage.getItem('solvencia')){
          setSolvencia('INSOLVENTE')
          setTimeout(() => {
            localStorage.removeItem('solvencia')
          }, 5000);
        }
        setCargando(false);
        }).catch(() => setCargando(false));

      loadMenu();
    }else{
      history.push("/"); 
    }
  },[datos, history, dataUser]);

  // Datos derivados para presentación (antes se calculaban con setState durante el render)
  const resultados = toefl.length > 0 ? toefl : [];
  let fechaExamen = '';
  let tipoToefl = '';
  if (resultados.length > 0) {
    let fecha = new Date(resultados[0].toefl_fecha);
    let formatFecha = fecha.toLocaleString().split(',');
    fechaExamen = formatFecha[0];
    tipoToefl = resultados[0].tipotoefl;
  }

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto
            foto={dataUser.carnet}
            alt="Foto alumno"
            tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            perfil={dataUser.perfil}
            carrera={dataUser.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">TOEFL</h2>

        {cargando ? (
          <>
            <div className="esen-stat-grid">
              <SkeletonCard rows={1} title={false} />
            </div>
            <SkeletonCard rows={4} />
          </>
        ) : resultados.length > 0 ? (
          <>
            <div className="esen-stat-grid">
              <div className="esen-stat esen-stat--hero">
                <div>
                  <div className="esen-stat-value">Aprobado</div>
                  <div className="esen-stat-label">
                    {tipoToefl} · Examen realizado el {fechaExamen}
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Componente</th>
                        <th scope="col" className="text-right">Puntaje</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resultados.map((element) => (
                        <CarToefl datos={element} key={element.estructura} />
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        ) : solvencia ? (
          <div className="alert alert-danger" role="alert">
            <i className="fa fa-exclamation-circle mr-2" aria-hidden="true"></i>
            <b>Insolvente.</b> Regulariza tus pagos para consultar tu resultado de TOEFL.
          </div>
        ) : (
          <EmptyState icon="fa-globe" title="Aún no has realizado el TOEFL">
            Cuando realices el examen, tu resultado aparecerá en esta pantalla.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default Toefl;
